module.exports = __webpack_public_path__ + "assets/csv.fc9d55f08f4999e51bf3724674b95044.svg";


//////////////////
// WEBPACK FOOTER
// ./img/csv.svg
// module id = 918
// module chunks = 0